const groupSolutionsOurExpertiseFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const cardGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`card-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `card-${index}-category`)) {
      break;
    }

    cardGroups.push({ index, fields: groupFields });
  }

  return { introFields, cardGroups };
};

export default groupSolutionsOurExpertiseFields;
